/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  action.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:28
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import Vue from 'vue'
import store from '@/store'
import { flattenTree } from '@/utils/util'

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = Vue.directive('action', {
  inserted: function(el, binding, vnode) {
    const actionName = binding.arg
    const elVal = vnode.context!.$route.meta!.permission
    if (elVal && elVal instanceof Array && !elVal.includes(actionName)) {
      (el.parentNode && el.parentNode.removeChild(el)) || (el.style.display = 'none')
    }
  }
})
export default action
Vue.prototype.$action = function(actionName: string, isToast?: number) {
  const permission = this.$route.meta.permission
  let limit = permission && this.$route.meta.permission instanceof Array && permission.includes(actionName)
  if (!limit && isToast !== 0) {
    this.$toast('暂无此操作权限，请联系管理员')
  }
  return limit
}

// 用与某些路由和权限层级不匹配的情况 (所有权限可使用,但不建议使用)
Vue.prototype.$isAction = function(actionName) {
  const menus = [].concat.apply(
          [],
          [...(flattenTree(store.getters.roles!) || [])]
  )
  let elVal = menus.map(item => {
    return item.actionName
  })
  return !(elVal && elVal instanceof Array && !elVal.includes(actionName))
}

